import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
api.interceptors.request.use(c => {
  const t = localStorage.getItem("token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    // Un 401 durante il login significa semplicemente credenziali errate.
    // Gli altri 401 indicano una sessione non più valida.
    if (
      status === 401 &&
      !url.endsWith("/auth/login") &&
      localStorage.getItem("token")
    ) {
      localStorage.removeItem("token");
      window.dispatchEvent(new Event("auth:session-expired"));
    }

    return Promise.reject(error);
  }
);

export const DAY_LABELS_SHORT = ["Lun","Mar","Mer","Gio","Ven","Sab","Dom"];
export const DAY_LABELS = ["Lun","Mar","Mer","Gio","Ven","Sab","Dom"];
export function statusLabel(status) {
  return {aperto:"Attivo",chiuso:"Fuori orario",in_eccezione:"In eccezione",sospeso:"Servizio sospeso",info:"Struttura"}[status] || "—";
}

export async function openDocumentBlob(id) {
  try {
    const r = await api.get(`/documents/${id}/file`, { responseType: "blob" });
    const url = window.URL.createObjectURL(r.data);
    const w = window.open(url, "_blank");
    if (!w) window.alert("Il browser ha bloccato la finestra: consenti i popup per aprire i documenti.");
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  } catch (err) {
    window.alert(err.response?.data?.detail || "Impossibile aprire il documento");
  }
}
